import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const LinkIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props

  return (
    <svg
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '100%'}
      height={height ? height : '100%'}
    >
      <path
        d="M32 3.04775C30.8241 3.56859 29.5593 3.91612 28.2252 4.08055C29.5815 3.27528 30.625 1.99095 31.1147 0.473738C29.8455 1.21768 28.4394 1.7643 26.9435 2.05227C25.749 0.785712 24.0451 0 22.1573 0C18.5309 0 15.5916 2.91354 15.5916 6.50612C15.5916 7.01453 15.6511 7.5096 15.7631 7.99045C10.3076 7.71669 5.46888 5.12313 2.23181 1.18746C1.66297 2.14915 1.343 3.27528 1.343 4.46363C1.343 6.72211 2.49935 8.71039 4.26276 9.88184C3.1864 9.84896 2.17315 9.54943 1.28611 9.06947C1.28611 9.08902 1.28611 9.11835 1.28611 9.14591C1.28611 12.3021 3.54993 14.9303 6.55057 15.5285C6.00217 15.6787 5.42266 15.7622 4.82538 15.7622C4.40141 15.7622 3.98811 15.7142 3.58815 15.6423C4.42363 18.2216 6.84743 20.1068 9.71919 20.1628C7.47227 21.9048 4.64228 22.9483 1.5652 22.9483C1.03369 22.9483 0.513735 22.9181 0 22.8559C2.90731 24.6966 6.35947 25.7756 10.0649 25.7756C22.1395 25.7756 28.7452 15.86 28.7452 7.25806C28.7452 6.97631 28.7363 6.69544 28.7229 6.41813C30.0117 5.50799 31.1227 4.35964 32 3.04775Z"
        fill="#03A9F4"
      />
    </svg>
  )
}

export default LinkIcon
